import React from 'react'

import { PANEL_ENVS } from 'utils/constants/environments'

import PlanBase from '../Base'

export default function () {
  return (
    <PlanBase docType={PANEL_ENVS.CPF} />
  )
}
